import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";
import { useStripe } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import PendingRoundedIcon from "@mui/icons-material/PendingRounded";
import { useNavigate } from "react-router-dom";
import { useWeb3Context } from "../../context/UseWeb3Context";

const ShowStatus = () => {
  const { account } = useWeb3Context();

  const stripe = useStripe();

  const [message, setMessage] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret || !account) {
      return;
    }
    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      setPaymentStatus(paymentIntent.status);
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe, account]);
  return (
    <Box display="flex" alignItems="center" justifyContent="center" mt={5}>
      <Card sx={{ width: "30%", p: 2, textAlign: "center" }} variant="outlined">
        <CardContent>
          {paymentStatus === "succeeded" && (
            <CheckCircleOutlineOutlinedIcon color="success" fontSize="large" />
          )}
          {paymentStatus === "processing" && (
            <PendingRoundedIcon color="primary" fontSize="large" />
          )}
          {paymentStatus === "requires_payment_method" && (
            <ErrorOutlinedIcon color="error" fontSize="large" />
          )}
          <Typography fontWeight="500" variant="h6">
            {message}
          </Typography>
          {!message && (
            <Typography fontWeight="500" variant="h6">
              Please wait while we confirm your payment status.
              <br />
              Do not refresh or hit back.
            </Typography>
          )}
        </CardContent>
        <CardActions
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={() => navigate("/")}
            sx={{ "&:hover": { background: "white" } }}
            variant="contained"
            size="small"
          >
            Back to Home
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
};

export default ShowStatus;
